import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a948416"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-7" }
const _hoisted_2 = { class: "d-flex flex-row gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_5 = { class: "d-flex flex-row gap-3" }
const _hoisted_6 = { class: "d-flex flex-column gap-3 ps-0 col-8" }
const _hoisted_7 = { class: "ps-4 d-flex flex-row" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex h-100"
}
const _hoisted_9 = { class: "d-flex flex-column ps-3 mb-0" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-row gap-3 align-items-center my-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z",
    fill: "#1BC5BD"
  })
], -1))
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = { class: "text-center mt-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "d-flex flex-row gap-2 mt-3 justify-content-between",
  id: "group-btn"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Ordenar", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fs-6 fas fa-cog" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fs-6 fas fa-trash-alt" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir esse pacote?", -1))
const _hoisted_25 = { class: "dialog-footer d-flex flex-row gap-3 justify-content-end" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  class: "d-flex flex-row justify-content-end gap-4",
  style: {"position":"absolute","top":"0.5rem","right":"0.5rem"}
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z",
    fill: "#dc3545 "
  })
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z",
    fill: "#dc3545 "
  })
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z",
    fill: "#dc3545 "
  })
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "card col ps-2 pe-2 pb-2" }
const _hoisted_38 = {
  key: 2,
  class: "text-center m-auto w-50"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog fs-1 mt-4" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir esse cardápio?", -1))
const _hoisted_41 = { class: "dialog-footer d-flex flex-row gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Folder = _resolveComponent("Folder")!
  const _component_DraggableList = _resolveComponent("DraggableList")!
  const _component_FormEdit = _resolveComponent("FormEdit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Cardápio de pacotes - Loja: " + _toDisplayString(_ctx.cardapioLoja.loja && _ctx.cardapioLoja.loja.nomeFantasia), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          text: "Novo cardápio",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.populaForm('cardapio', _ctx.idLoja)))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/lojas",
          style: {"height":"fit-content","white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { text: "Voltar" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardapioLoja.cardapio, (tituloCardapio, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "p-2 card",
            key: key
          }, [
            _createVNode(_component_Folder, {
              folderName: tituloCardapio.nome,
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardapioLoja.configuracaoCardapio, (pacoteCardapio, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-3 col-4",
                      key: key,
                      style: _normalizeStyle(tituloCardapio.id === Number(pacoteCardapio.idCardapio) ? {} : { display: 'none' })
                    }, [
                      (tituloCardapio.id === Number(pacoteCardapio.idCardapio))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_Folder, {
                              folderName: pacoteCardapio.descricao,
                              style: {"box-shadow":"-3px 3px 8px -6px rgba(0,0,0,0.75)","background-color":"#f8f8f8","padding-right":"1rem","margin-right":"1rem","width":"100%","min-height":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardapioLoja.itens, (itensCardapio, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      style: {"overflow":"hidden"},
                                      key: key
                                    }, [
                                      (tituloCardapio.id === Number(itensCardapio.idCardapio) && pacoteCardapio.id === itensCardapio.codConfigPacote)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _hoisted_11,
                                            _createElementVNode("span", {
                                              class: "d-inline-block pe-2",
                                              title: itensCardapio.servico,
                                              onClick: ($event: any) => (_ctx.populaForm('itens', itensCardapio.codAgregados))
                                            }, _toDisplayString(itensCardapio.servico), 9, _hoisted_12)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (_ctx.populaForm('addItem', pacoteCardapio.id), _ctx.iniciarComMarcacao = tituloCardapio.qtd),
                                      class: "text-danger fs-8",
                                      style: {"cursor":"pointer"}
                                    }, "Adicionar item", 8, _hoisted_14)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", {
                                    class: "p-1 btn btn-sm btn-light-danger gap-3 col-6",
                                    onClick: ($event: any) => (_ctx.montaArrayItensPacote(pacoteCardapio.id), _ctx.openDragDrop = true, _ctx.codConfigPacote = pacoteCardapio.id)
                                  }, _hoisted_18, 8, _hoisted_16),
                                  _createElementVNode("button", {
                                    class: "p-1 btn btn-sm btn-light-danger gap-3 col",
                                    onClick: ($event: any) => (_ctx.populaForm('configuracaoCardapio', pacoteCardapio.id))
                                  }, _hoisted_21, 8, _hoisted_19),
                                  _createElementVNode("button", {
                                    class: "p-1 btn btn-sm btn-light-danger gap-3 col",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.typeForm = 'configuracaoCardapio' , _ctx.dialogVisible = true))
                                  }, _hoisted_23)
                                ]),
                                (_ctx.dialogVisible && _ctx.typeForm === 'configuracaoCardapio')
                                  ? (_openBlock(), _createBlock(_component_el_dialog, {
                                      key: 0,
                                      modelValue: _ctx.dialogVisible,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
                                      title: "Confirme sua ação",
                                      width: "30%"
                                    }, {
                                      footer: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_25, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-sm btn-light-danger",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
                                          }, "Cancelar"),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-sm btn-light-danger",
                                            onClick: ($event: any) => (_ctx.deleteAnyCardapio({codConcessionaria: _ctx.idLoja, cardapioConfig: pacoteCardapio.id}))
                                          }, "Confirmar", 8, _hoisted_26)
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_24
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["folderName"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (tituloCardapio.qtd < 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        title: "Adicionar pacote",
                        class: "btn btn-sm d-flex flex-row p-0 align-items-center",
                        onClick: ($event: any) => (_ctx.populaForm('configuracaoCardapio', tituloCardapio.id))
                      }, _hoisted_30, 8, _hoisted_28))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    title: "Configurar cardápio",
                    class: "btn bg-transparent d-flex flex-row p-0 align-items-center",
                    onClick: ($event: any) => (_ctx.populaForm('cardapio', tituloCardapio.id))
                  }, _hoisted_33, 8, _hoisted_31),
                  _createElementVNode("button", {
                    title: "Excluir cardápio",
                    class: "btn btn-sm d-flex flex-row p-0 align-items-center",
                    onClick: ($event: any) => (_ctx.typeForm = 'cardapio' , _ctx.idDeleteCardapioFunction(tituloCardapio.id))
                  }, _hoisted_36, 8, _hoisted_34)
                ])
              ]),
              _: 2
            }, 1032, ["folderName"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_37, [
        (_ctx.openDragDrop)
          ? (_openBlock(), _createBlock(_component_DraggableList, {
              key: 0,
              produtos: _ctx.itensPacote,
              onOrdenaItens: _ctx.ordenaItens
            }, null, 8, ["produtos", "onOrdenaItens"]))
          : _createCommentVNode("", true),
        (_ctx.openEdit && !_ctx.openDragDrop)
          ? (_openBlock(), _createBlock(_component_FormEdit, {
              key: 1,
              onGetCardapioById: _ctx.getCardapioById,
              onDelete: _ctx.deleteAnyCardapio,
              codConcessionaria: _ctx.idLoja!,
              estoque: _ctx.cardapioLoja.estoque,
              arrayGrupos: _ctx.cardapioLoja.grupoExibicao,
              iniciarComMarcacao: _ctx.iniciarComMarcacao!,
              formItem: _ctx.formItem,
              formCardapio: _ctx.formCardapio,
              formPacote: _ctx.formPacote,
              itensFixos: _ctx.cardapioLoja.itensFixos,
              itensDinamicos: _ctx.cardapioLoja.itensDinamicos,
              typeForm: _ctx.typeForm,
              onCloseForm: _ctx.closeForm
            }, null, 8, ["onGetCardapioById", "onDelete", "codConcessionaria", "estoque", "arrayGrupos", "iniciarComMarcacao", "formItem", "formCardapio", "formPacote", "itensFixos", "itensDinamicos", "typeForm", "onCloseForm"]))
          : _createCommentVNode("", true),
        (!_ctx.openDragDrop && !_ctx.openEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_component_Title, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Crie, edite ou apague o cardápio da loja, pacote ou os itens ")
                ]),
                _: 1
              }),
              _hoisted_39
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.dialogVisible && _ctx.typeForm === 'cardapio')
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "Confirme sua ação",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteAnyCardapio({codConcessionaria: _ctx.idLoja, cardapioPacote: _ctx.idDeleteCardapio})))
              }, "Confirmar")
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}